const { Login } = require("components/auth");

const LoginPage = () => {
  return (
    <>
      <Login />
    </>
  );
};
export { LoginPage };
